import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { ServicioAutenticacion } from './auth.service';
import { ToastService } from '../services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class GuardiaAutenticacion implements CanActivate {
  constructor(
    private servicioAutenticacion: ServicioAutenticacion,
    private router: Router,
    private toastService: ToastService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    const rolesPermitidos = route.data['roles'] as Array<string>;
    const rolesUsuario = this.servicioAutenticacion.obtenerRolesDesdeToken();
    if (this.servicioAutenticacion.obtenerToken()) {
      if (this.verificarRoles(rolesUsuario, rolesPermitidos)) {
        return true;
      } else {
        this.toastService.mostrarNotificacion(
          'No tiene permisos para acceder a esta página. En caso que sea un error, inicie sesión nuevamente',
          'warning'
        );
        this.router.navigate(['/home']);
        return false;
      }
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

  private verificarRoles(
    rolesUsuario: string[],
    rolesPermitidos: string[]
  ): boolean {
    if (!rolesPermitidos || rolesPermitidos.length === 0) {
      return true;
    }
    return rolesUsuario.some((role) => rolesPermitidos.includes(role));
  }
}
